import { render, staticRenderFns } from "./ScrumSettings.vue?vue&type=template&id=1e5195b6&"
import script from "./ScrumSettings.vue?vue&type=script&lang=ts&"
export * from "./ScrumSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports